import React, {useCallback} from "react";
import { auth } from "firebase/app";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import get from "lodash/get";
import { toastr } from "react-redux-toastr";

import { userUpdateProfileSuccess } from "../../../store/modules/session/actions";
import { getUser } from "../../../store/modules/session/selectors";

import {
  FormActionTypes,
  FORM_TITLE,
  ValueTypes,
  validationSchema,
} from "./formSettings";
import { FormComponent } from "./FormComponent";

export const AccountForm: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);

  const handleOnSubmit = useCallback((values: ValueTypes, actions: FormActionTypes) => {
    const profile = {
      displayName: get(values, "displayName") || null,
      photoURL: get(values, "photoURL") || null,
    };
    const user = auth().currentUser;

    if (user) {
      user.updateProfile(profile)
        .then(() => {
          dispatch(userUpdateProfileSuccess(user));
          toastr.success(FORM_TITLE, "User is updated.");
        })
        .catch(({ message }) => {
          toastr.error(FORM_TITLE, message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } else {
      toastr.error(FORM_TITLE, "User is undefined.");
      actions.setSubmitting(false);
    }
  }, [dispatch]);

  const initialValues = {
    displayName: get(user, "displayName") || "",
    photoURL: get(user, "photoURL") || "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleOnSubmit}
      component={FormComponent}
      enableReinitialize
    />
  );
};
